import React from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import LoadingOverlay from 'react-loading-overlay';
import getInsegnanti from '../../services/getInsegnanti';
import getLezioniPresenzaPerInsegnante from '../../services/getLezioniPresenzaPerInsegnante';
import moment from 'moment';
import Utils from '../../utils/utils';
import { NineCellLoading } from 'react-loadingg';
import translateString from "../../utils/Locales";

let t = translateString;

export default class Invoices extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.userslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: true,
      addElementVisible: false,
      nome: '',
      cognome: '',
      mail: '',
      mail2Tipo: '',
      mail2: '',
      indirizzo: '',
      citta: '',
      codiceFiscale: '',
      telefono: '',
      telefono2Tipo: '',
      telefono2: '',
    }

    this.grid = 2;

    this.pageTitle = "Ore da fatturare";
    this.startDateRef = React.createRef();
    this.endDateRef = React.createRef();

    this.state = { 
      isLoading: true,
    }

  }


  async componentDidMount(){

    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentInsegnante = cookies.get('currentInsegnante', { path: '/' });

    Utils.setAnalyticsPage('Invoices list for teacher: ' + currentInsegnante + ' - ' + cookies.get('db', { path: '/' }));

    this.insegnanti = await getInsegnanti(username, token);
    this.insegnante = undefined;

    this.insegnanti.forEach(i => {
      if (i.id == currentInsegnante)
        this.insegnante = i;
    });

    this.lezioni = await getLezioniPresenzaPerInsegnante(username, token, this.insegnante.id);

    this.lezioni.sort((l1, l2) => {
      var data1 = moment(l1.data, "yyyy-MM-DD HH:mm:ss");
      var data2 = moment(l2.data, "yyyy-MM-DD HH:mm:ss");
      return data1 > data2 ? -1 : 1;
    })

    this.mesi = [];

    this.lezioni.forEach(l => {
      var ll = moment(l.data, "yyyy-MM-DD HH:mm:ss");
      var mmYYYY = moment(ll).format('yyyy-MM');
      if (this.mesi.indexOf(mmYYYY) == -1){
        this.mesi.push(mmYYYY);
      }
    })

    this.lezioniPerMese = [];

    this.mesi.forEach(mese => {
      var lezioniMese = this.lezioni.filter(l => {
        var mmYYYY = moment(l.data).format('yyyy-MM');
        if (mmYYYY == mese) return true;
        return false;
      });

      var countOre = 0;
      lezioniMese.forEach(l => {
        var durata = l.durata / 60;
        if (l.divisione_fatturato == 1){
          var numInsegnanti = 1 + l.altri_insegnanti.split(';').length - 1;
          durata = durata / numInsegnanti;
        }

        countOre += durata;
      });

      this.lezioniPerMese[mese] = countOre;
      //this.lezioniPerMese[moment(mese, "yyyy-MM").format('LLL')] = countOre;
    })


    this.setState({
      insegnante: this.insegnante,
      inputCorso: '', 
      isLoading: false,
    });
  }

  render () {

    function createData(username, name, surname) {
      return { username, name, surname };
    }

    var rows = [];
    this.userslist.length > 0 && this.userslist.map((v, k) => {
      rows.push(createData(v.username, v.name, v.surname));
    });

    if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />

    if (this.state.insegnante == undefined) return <div/>;

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={'Loading your content...'}
      >
        <PageTitle title={t('ore_fatturare')} />
          
        <div style={{fontWeight: 'bold'}}>{this.state.insegnante.cognome + ' ' + this.state.insegnante.nome}</div>
        <table style={{borderCollapse: 'collapse'}}>
        { (!this.mesi || this.mesi.length === 0) &&
           <div style={{ width: '100%', marginTop: 100, display: 'flex', flexDirection: 'column', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
              <img src={ require('../../images/nothing.png') } style={{ width: 200, height: 200, opacity: 0.5 }} />
              <p style={{ color: 'darkgrey', fontSize: 16, fontWeight: 'bold', textAlign: 'center', marginLeft: 40, marginRight: 40 }}>{t('no_dati')}</p>
          </div>
        }
        {
          this.mesi.map(mese => {
            var mmmm = Utils.capitalizeFirstLetter(moment(mese, "yyyy-MM").format('MMMM yyyy'));
            return <tr style={tr}><td>{mmmm} </td><td style={td}>{this.lezioniPerMese[mese] + ' ore'} </td></tr>
          })
        }
        </table>
        </LoadingOverlay>
      </>
    );
  }


}

const td = {
  padding: '5px',
}

const tr = {
}